var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonPipelineB = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M40.231 24.01H21.984v16.043H40.23V24.01z", fill: fills.light }),
        React.createElement("path", { d: "M40.25 40.046c2.071 0 3.75-3.584 3.75-8.004s-1.679-8.004-3.75-8.004c-2.071 0-3.75 3.583-3.75 8.004 0 4.42 1.679 8.004 3.75 8.004z", fill: fills.light }),
        React.createElement("path", { d: "M27.98 22.034h-6.013V42h6.013V22.034z", fill: fills.dark }),
        React.createElement("path", { d: "M27.898 41.998c3.08 0 5.576-4.47 5.576-9.982 0-5.513-2.496-9.982-5.576-9.982-3.08 0-5.578 4.47-5.578 9.982 0 5.513 2.497 9.982 5.578 9.982zM25 3c-1.102 0-2 .792-2 1.766V18h4V4.766C27 3.792 26.102 3 25 3z", fill: fills.dark }),
        React.createElement("path", { d: "M21.932 41.998c3.08 0 5.577-4.47 5.577-9.982 0-5.513-2.497-9.982-5.577-9.982s-5.577 4.47-5.577 9.982c0 5.513 2.497 9.982 5.577 9.982z", fill: fills.dark }),
        React.createElement("path", { d: "M21.974 40.048c2.074 0 3.755-3.589 3.755-8.016s-1.68-8.015-3.755-8.015c-2.073 0-3.755 3.588-3.755 8.015 0 4.428 1.682 8.016 3.755 8.016z", fill: fills.light }),
        React.createElement("path", { d: "M21.977 24.01H7.78v16.043h14.196V24.01z", fill: fills.light }),
        React.createElement("path", { d: "M7.694 40.07c2.074 0 3.755-3.59 3.755-8.016 0-4.428-1.681-8.016-3.755-8.016s-3.755 3.588-3.755 8.016c0 4.427 1.681 8.016 3.755 8.016z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
